import ModalSidebar from 'components/UI/ModalSidebar/ModalSidebar';
import { PARTIAL_UPDATE_TYPE } from 'constants/deployment';
import {
  FRONT_ROUTER,
  DEPLOYMENT_UPDATE_PARTIAL_PARAMS_KEY,
} from 'constants/router';
import { ReactElement } from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * @description Component wrapping content in a modal sidebar with title based on partial deployment update type.
 *
 * @SADtrace SAD-003-6.1
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 * 09-30-2026 aleksandar dukleski: DLA-1446 removed the update-to-full-deployment route; its URL now redirects to the error page
 *
 * @param {Object} props - Component props
 * @param {ReactElement} props.children - The content to be displayed inside the modal sidebar
 *
 * @returns {ReactElement} Rendered component or redirect to error page
 */
const ModalSidebarWrapper = ({ children }: { children: ReactElement }) => {
  const { [DEPLOYMENT_UPDATE_PARTIAL_PARAMS_KEY]: updateType } = useParams();

  let translation = '';

  switch (updateType) {
    case PARTIAL_UPDATE_TYPE.REVERT:
      translation = 'deployment.form.modal__update__partial__deployment-revert';
      break;
    case PARTIAL_UPDATE_TYPE.UPDATE_TO_FULL_LIBRARY:
      translation =
        'deployment.form.modal__update__partial__deployment-library';
      break;

    default:
      translation = FRONT_ROUTER.ERROR;
      break;
  }

  if (translation === FRONT_ROUTER.ERROR) {
    return <Navigate to={FRONT_ROUTER.ERROR} />;
  }

  return <ModalSidebar title={translation}>{children}</ModalSidebar>;
};

export default ModalSidebarWrapper;
